import React, { useEffect, useState, useRef } from "react"
import { useInView } from "react-intersection-observer"
import useIsMobile from "../../../hooks/useIsMobile"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "./designSection.scss"
import Slide from "./slide"
import PopUp from "./popup"

const DesignSection = ({
  design,
  pageContext
}) => {

  const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: design.designFlexFields.slideroptions?.autoplay || false,
    autoplaySpeed: design.designFlexFields.slideroptions?.transitionTime || 2000,
    pauseOnHover: false,
    fade: design.designFlexFields.slideroptions?.transitionStyle === "fade" ? true : false,
    responsive: [
      {
        breakpoint: 980,
        settings: "unslick",
      },
    ],
  }

  const sliderRef = useRef()

  const [ref, inView] = useInView({ threshold: 0.9 })
  const [sliderKey, updateSliderKey] = useState(0)
  const isMobile = useIsMobile()
  const [background, setBackground] = useState("white")

  // This code is to focus slider element on load
  // as the keyboard navigation only works when slider is in focus (i.e. only works if user clicks slider first)
  // https://github.com/akiran/react-slick/issues/1893
  React.useEffect(() => {

    if(!sliderRef?.current) 
      return

    const track = sliderRef.current.innerSlider.list.querySelector('.slick-track');

    const focusSlider = setTimeout(() => {
      const slide = track.querySelector('.slick-slide');
      slide.focus();
    }, 1500);

    return () => clearTimeout(focusSlider);
  }, []);


  // set background color
  useEffect(() => {
    if (design) {
      setBackground(
        design.acf.background !== "custom"
          ? design.acf.background
          : design.design.acf.custom
      )
    }
  }, [design])

  const designSectionClass = `${isMobile ? "mobile" : ""} design-section ${inView ? "active" : ""}`

  if (!design)
    return <></>

  return (
    <div
      name={design.slug}
      ref={ref}
      className={designSectionClass}
      id={design.slug}
      style={{ background: background }}
    >
      <Slider
        {...sliderSettings}
        ref={slider => (sliderRef.current = slider)}
        beforeChange={e => updateSliderKey(e + 1)}
      >
        {design.designFlexFields.slides.map((element, index) => (
          <Slide
            element={element}
            key={index}
            inView={inView}
            slug={design.slug}
            next={() => sliderRef.current.slickNext()}
            prev={() => sliderRef.current.slickPrev()}
            pageContext={pageContext}
          />
        ))}
      </Slider>
      <PopUp
        element={design.designFlexFields.popUp}
        inView={inView}
        display={sliderKey ? false : true}
      />
    </div>
  )
}

export default DesignSection
